import React from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { AssignmentsProvider } from "./contexts/AssignmentsContext";
import LogoutBox from "./components/nav/LogoutBox";
import { RulesProvider } from "./contexts/RulesContext";

const Home: React.FC = () => {
  const navigate = useNavigate();

  React.useEffect(() => {
    navigate("/assignments");
  }, [navigate]);

  return (
    <AssignmentsProvider>
      <RulesProvider>
        <LogoutBox />
        <Outlet />
      </RulesProvider>
    </AssignmentsProvider>
  );
};

export default Home;
